<div class="sidebar-wrapper notification">
  <p-sidebar styleClass="p-sidebar-md" dismissible="false" blockScroll="false" position="right" cache="false"
    [showCloseIcon]="false" [dismissible]="false" [baseZIndex]="baseZIndex" [visible]="isSidebarVisible"
    (onHide)="handleHideSidebar()">
    <div class="sidebar-container" #sidebarContainer>
      <div class="ui-g header-dropdown-list">
        <div class="ui-g-12 flex-between-center pt-2">
          <div class="pl-4">
            <span class="font-18 font-700">Notifications</span>
          </div>

          <div class="flex-end-center">
            <div *ngIf="_notifications.old.length || urgentNotifications.length"
              class="font-13 text-right font-gray-45 hover-underline pointer" (click)="dismissAllNofication()">
              Dismiss all
            </div>
            <button class="btn btn-sm" (click)="markAllRead()">
              <i class="fal fa-times font-13 font-gray-45 sidebar-close-icon"></i>
            </button>
          </div>
        </div>

        <div class="ui-g-12">
          <p-tabView class="sidebar-scroll tab-panel-underline tab-panel-default" [activeIndex]="index" (onChange)="handleTabChange($event)">
            <p-tabPanel>
              <ng-template pTemplate="header">
                <span [ngClass]="{'font-700': index === 0}">Urgent</span>
                <span class="count-notify">{{urgentCount || 0}}</span>
              </ng-template>

              <div *ngIf="!loader.urgentNotification" class="notification-content"
                [ngClass]="{'no-notification': urgentNotifications.length === 0}">
                <div class="ui-g-12" [ngClass]="{'notification-section':urgentNotifications.length}">
                  <div class="empty-box text-center" *ngIf="!urgentNotifications.length">
                    <i class="fas fa-box"></i>
                    <h3 class="m-0 font-16 font-700 mt-3">No new notifications</h3>
                    <p class="m-0 font-14 p-0">Looks like you are all caught up</p>
                  </div>
                  <div *ngFor="let urgentNotif of urgentNotifications; let i = index">
                    <div *ngIf="urgentNotif?.priority === 'urgent'">

                      <!-- Estimate authorized -->
                      <div class="unread-notification-item notify-item " (click)="goToEstimate(urgentNotif)"
                        [ngClass]="{'slide-out': deletedElement === i}"
                        *ngIf="urgentNotif?.moduleName === 'order' && urgentNotif?.appAction?.actionType === 'assign-technician'">
                        <span class="read-dot" *ngIf="!urgentNotif?.isSeen"></span>
                        <div class="ui-g-8 p-0">
                          <p class="m-0 font-13 font-bold p-0 hover-underline heading">
                            Estimate authorized on
                            <span class="font-primary hover-underline pointer order-number">RO#
                              {{urgentNotif?.data?.code}} <i class="fal fa-external-link hover-icon ml-1"></i></span>
                          </p>
                          <!-- <div class="flex-start-center flex-wrap">
                            <p class="m-0 p-0 font-12" [innerHTML]="urgentNotif?.text">
                            </p>
                          </div> -->
                          <div class="flex-start-center flex-wrap"
                            *ngIf="urgentNotif?.data && urgentNotif?.data.serviceStatusCount">
                            <span class="notificationtag"
                              *ngIf="urgentNotif?.data?.serviceStatusCount?.approved">Authorized:
                              {{urgentNotif?.data?.serviceStatusCount?.approved}}</span>
                            <span class="notificationtag deferred"
                              *ngIf="urgentNotif?.data?.serviceStatusCount?.deferred">Deferred:
                              {{urgentNotif?.data?.serviceStatusCount?.deferred}}</span>
                            <span class="notificationtag declined"
                              *ngIf="urgentNotif?.data?.serviceStatusCount?.declined">Declined:
                              {{urgentNotif?.data?.serviceStatusCount?.declined}}</span>
                            <span class="notificationtag pending"
                              *ngIf="urgentNotif?.data?.serviceStatusCount?.pending">Pending:
                              {{urgentNotif?.data?.serviceStatusCount?.declined}}</span>
                          </div>
                          <p class="past-time p-0">{{showTime(urgentNotif?.createdAt)}}</p>
                        </div>
                        <div class="ui-g-4 flex-start-end flex-column p-0">
                          <button class="btn btn-sm p-0"
                            (click)="dismissNofication($event,urgentNotif);$event.stopPropagation()">
                            <i class="fal fa-times sidebar-close-icon"></i>
                          </button>
                          <button class="btn btn-border btn-sm font-11 font-bold mt-1"
                            (click)="handleAssignTech(urgentNotif);$event.stopPropagation()">
                            <span class="font-700">Assign technician</span>
                          </button>
                        </div>
                      </div>

                      <!-- Flag raised -->
                      <div class="unread-notification-item notify-item" (click)="redirectToEstimate(urgentNotif)"
                        [ngClass]="{'slide-out': deletedElement === i}"
                        *ngIf="urgentNotif?.moduleName === 'order' && (urgentNotif?.entityAction === 'flagRaised' || urgentNotif?.appAction?.actionType === 'view-tech-flag')">
                        <span class="read-dot" *ngIf="!urgentNotif?.isSeen"></span>
                        <div class="ui-g-8 p-0">
                          <p class="m-0 font-13 font-bold p-0 hover-underline heading">
                            Flag raised on
                            <span class="font-primary hover-underline pointer order-number">RO#
                              {{urgentNotif?.data?.code}} <i class="fal fa-external-link hover-icon ml-1"></i></span>
                          </p>
                          <div class="flex-start-center flex-wrap">
                            <p class="m-0 p-0 font-12" [innerHTML]="urgentNotif?.text">
                            </p>
                          </div>
                          <p class="past-time p-0">{{showTime(urgentNotif?.createdAt)}}</p>
                        </div>
                        <div class="ui-g-4 flex-between-end flex-column p-0">
                          <button class="btn btn-sm p-0"
                            (click)="dismissNofication($event,urgentNotif);$event.stopPropagation()">
                            <i class="fal fa-times sidebar-close-icon"></i>
                          </button>
                        </div>
                      </div>

                      <!-- Payment -->
                      <div class="unread-notification-item notify-item" (click)="goToEstimate(urgentNotif)"
                        [ngClass]="{'slide-out': deletedElement === i}"
                        *ngIf="urgentNotif?.moduleName === 'order' && urgentNotif?.appAction?.actionType === 'payment-view-contact'">
                        <span class="read-dot" *ngIf="!urgentNotif?.isSeen"></span>
                        <div class="ui-g-8 p-0">
                          <p class="m-0 font-13 font-bold p-0 hover-underline heading">
                            {{urgentNotif?.heading}}
                            <span class="font-primary hover-underline pointer order-number">RO# {{urgentNotif?.data &&
                              urgentNotif?.data?.code }} <i class="fal fa-external-link hover-icon ml-1"></i></span>
                          </p>
                          <div class="flex-start-center flex-wrap">
                            <p class="m-0 p-0 font-12" [innerHTML]="urgentNotif?.text">
                            </p>
                          </div>
                          <p class="past-time p-0">{{showTime(urgentNotif?.createdAt)}}</p>
                        </div>
                        <div class="ui-g-4 flex-between-end flex-column p-0">
                          <button class="btn btn-sm p-0"
                            (click)="dismissNofication($event, urgentNotif);$event.stopPropagation()">
                            <i class="fal fa-times sidebar-close-icon"></i>
                          </button>
                          <button class="btn btn-border btn-sm font-11 font-bold"
                            (click)="openContactUpdateDialog(urgentNotif);$event.stopPropagation()">
                            <span class="font-700">View Contact</span>
                          </button>
                        </div>
                      </div>

                      <!--  New appointment request -->
                      <div class="unread-notification-item notify-item"
                        (click)="redirectToPart(urgentNotif.moduleName, urgentNotif)"
                        [ngClass]="{'slide-out': deletedElement === i}"
                        *ngIf="urgentNotif?.moduleName === 'calendar' && urgentNotif?.appAction?.actionType === 'new-appt-request'">
                        <span class="read-dot" *ngIf="!urgentNotif?.isSeen"></span>
                        <div class="ui-g-8 p-0">
                          <p class="m-0 font-13 font-bold p-0 hover-underline heading">
                            {{urgentNotif?.heading}}
                            <!-- <span>{{for Ricardo Loma}}</span> -->
                          </p>
                          <div class="flex-start-center flex-wrap">
                            <p class="m-0 p-0 font-12" [innerHTML]="urgentNotif?.text">
                            </p>
                          </div>
                          <p class="past-time p-0">{{showTime(urgentNotif?.createdAt)}}</p>
                        </div>
                        <div class="ui-g-4 flex-between-end flex-column p-0">
                          <button class="btn btn-sm p-0"
                            (click)="dismissNofication($event,urgentNotif);$event.stopPropagation()">
                            <i class="fal fa-times sidebar-close-icon"></i>
                          </button>
                          <button class="btn btn-border btn-sm font-11 font-bold"
                            (click)="handleScheduleAppointment(urgentNotif);$event.stopPropagation()">
                            <span class="font-700">Schedule Appoinment</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div *ngIf="loader.urgentNotification" class="flex-center-center">
                <i class="fal fa-spinner rotate font-20"></i>
              </div>
            </p-tabPanel>


            <!-- OTHER TAB -->
            <p-tabPanel>
              <ng-template pTemplate="header">
                <span [ngClass]="{'font-700': index === 1}">Others</span>
                <span class="count-notify">{{otherCount || 0}}</span>
              </ng-template>

              <div *ngIf="!loader.otherNotification" class="notification-content"
                [ngClass]="{'no-notification': _notifications.old.length === 0}">
                <div class="ui-g-12" [ngClass]="{'notification-section': _notifications.old.length}">
                  <div class="empty-box text-center" *ngIf="!_notifications.old.length">
                    <i class="fas fa-box"></i>
                    <h3 class="m-0 font-16 font-700 mt-3">No new notifications</h3>
                    <p class="m-0 font-14 p-0">Looks like you are all caught up</p>
                  </div>
                  <div *ngFor="let newNot of _notifications.old;let i = index">
                    <div class="unread-notification-item notify-item" [ngClass]="{'slide-out': deletedElement === i}">
                      <span class="read-dot" *ngIf="!newNot?.isSeen"></span>
                      <div class="ui-g-8 p-0" [hidden]="newNot?.moduleName === 'order'"
                        (click)="redirectToPart(newNot.moduleName, newNot)">
                        <p *ngIf="newNot?.moduleName !== 'statement'" class="m-0 font-13 font-bold p-0"
                          [ngStyle]="{color: newNot?.isAlert ? 'var(--alert-700)' : '' }">
                          {{newNot?.heading}}
                        </p>
                        <p *ngIf="newNot?.moduleName === 'statement'" class="m-0 font-13 font-bold p-0"
                          [ngStyle]="{color: newNot?.isAlert ? 'var(--alert-700)' : '' }">
                          {{newNot?.title}}
                        </p>
                        <div class="flex-start-center flex-wrap">
                          <p class="m-0 p-0 font-12" [ngStyle]="{color: newNot?.isAlert ? 'var(--alert-900)' : '' }"
                            [innerHTML]="newNot?.text">
                          </p>
                        </div>
                        <p class="past-time p-0" [ngStyle]="{color: newNot?.isAlert ? 'var(--alert-700)' : '' }">
                          {{showTime(newNot?.createdAt)}} <span>{{newNot?.actionBy}}</span></p>
                      </div>

                      <div class="ui-g-8 p-0" [hidden]="newNot?.moduleName !== 'order'">
                        <p class="m-0 font-13 font-bold p-0"
                          [ngStyle]="{color: newNot?.isAlert ? 'var(--alert-700)' : '' }"
                          (click)="openEstimate(newNot)">
                          {{newNot?.heading}}
                        </p>

                        <div class="flex-start-center flex-wrap text-decoration-underline">
                          <p class="m-0 p-0 font-12 notification-text-ellipsis"
                            [ngStyle]="{color: newNot?.isAlert ? 'var(--alert-900)' : '' }" [innerHTML]="newNot?.text"
                            (click)="openEstimate(newNot)">
                          </p>
                        </div>
                        <p class="past-time p-0" [ngStyle]="{color: newNot?.isAlert ? 'var(--alert-700)' : '' }"
                          (click)="openEstimate(newNot)">{{showTime(newNot?.createdAt)}} <span
                            class="font-600">{{newNot?.actionBy}}</span></p>
                      </div>

                      <div class="ui-g-4 flex-start-end flex-column p-0">
                        <button class="btn btn-sm p-0" (click)="dismissOtherNofication($event,newNot)">
                          <i class="fal fa-times sidebar-close-icon"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div *ngIf="loader.otherNotification" class="flex-center-center">
                <i class=" fal fa-spinner rotate font-20"></i>
              </div>

            </p-tabPanel>
          </p-tabView>
        </div>

        <div class="ui-g-12 notificaiton-footer text-center">
          <p class="font-11 font-primary mb-0 link pointer" (click)="ViewAll()">View all notifications</p>
        </div>
      </div>


    </div>
  </p-sidebar>
</div>
